export default {
    filters: {
        title: "Filtre",
        removeFilter: "Fjern filter",
        filterIntensity: "Filterintensitet",
        duotone: {
            title: "Duotone",
            desert: "Ørken",
            peach: "Fersken",
            clash: "Clash",
            plum: "Plomme",
            breezy: "Brisk",
            deepBlue: "Dyp blå",
            frog: "Frosk",
            sunset: "Solnedgang",
        },
        blackAndWhite: {
            title: "Svart-hvitt",
            ad: "1920 E.Kr",
            greyed: "Grånet",
            dusty: "Støvete",
            litho: "Litografi",
            sepia: "Sepia",
            weathered: "Værslitt",
            hardStuff: "Tøff materie",
        },
        vintage: {
            title: "Vintasje",
            polaroid: "Polaroid",
            sunny: "Solrike 70-tallet",
            oldTimer: "Veteranbil",
            inferno: "Inferno",
            snappy: "Rask",
        },
        smooth: {
            title: "Jejn",
            chestnut: "Kastanje",
            softy: "Mysing",
            pebble: "Småstein",
            moss: "Moss",
            lemon: "Sitron",
            greenGap: "Grønt gap",
        },
        cold: {
            title: "Kald",
            colla: "Colla",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Zephyr",
        },
        warm: {
            title: "Varm",
            golden: "Gull",
            lowFire: "Lavt bål",
            sunrise: "Soloppgang",
            flatBack: "Flatrygg",
            pumpkin: "Gresskar",
        },
    },
};
